

























































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import moment from "moment";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  @Prop() grounds!: any[];

  @Prop() addData!: any;

  @Prop() allowHalfAnHour!: any;

  // @Prop() item!: any;

  item:any = null;
  personitem:any = null;

  price = "";

  priceArr: string[] = [];

  priceType = "0";
  count='4';

  renderHour(hto: any, mto: any, hfrom: any, mfrom: any): number {
    const x: moment.Moment = moment({ h: hto, m: mto });
    const y: moment.Moment = moment({ h: hfrom, m: mfrom });

    const duration = moment.duration(x.diff(y));

    return duration.as("hours");
  }

  changePriceType(e: any) {
    // console.log(e);
    this.priceType = e.target.value;
    if (e.target.value == "1") {
      this.price = this.priceArr[1] == "-" ? "" : this.priceArr[1];
    } else {
      this.price = this.priceArr[0] == "-" ? "" : this.priceArr[0];
    }
  }

  renderTime(v:any,d:any) {
    if(v==undefined) {
      return d || ""
    }
    return v
  }

  renderWeeks(){
    var weeks=this.form.getFieldValue("weeks")||this.addData.weeks;
    if(weeks==undefined){
      return 0
    }
    return weeks.length
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("stadium/editStadiumPrice", {
              stadium_id: this.stadiumId,
              type:this.addData.type||1,
              ...this.setitem(values)
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          }
        });
      }
    });
  }

  getitem(is_obj:any=false) {
    if(is_obj===true){
      const item= this.priceType=='0'?this.item:this.personitem;
      const data=item?item:this.addData;
      return data;
    }
    return this.addData;
  }

  setitem(values:any) {
    return values;
    const data= this.getitem(true);
    values.hour_from=data.hour_from;
    values.min_from=data.min_from;
    values.hour_to=data.hour_to;
    values.min_to=data.min_to;
    return values;
  }

  getpremium(){
    const item=this.getitem(true);
    if(!item){
      return '';
    }
    return item.premium_price||'';
  }

  mounted() {
    this.spinLoading = true;
    // 加载
    console.log('addData',this.addData);
    this.priceArr =['-','-'];// this.addData.price.replace(/<\/?.+?>/g, "").split("/");
    this.item=this.addData.item||null;
    this.personitem = this.addData.personitem || null;
    if(this.item){
      this.priceArr[0]=''+this.item.price;
    }
    if(this.personitem){
      this.priceArr[1]=''+this.personitem.price;
      this.count=this.personitem.color || '4';
    }
    if (this.priceArr[0] == "-") {
      this.price = "";
    } else {
      this.price = this.priceArr[0];
    }

    this.spinLoading = false;
  }
}
